module.exports = __webpack_public_path__ + "static/media/inbound.a96ae01d.png";